<template>
  <div>
    <div class="UserSpecificInformation" id="lLJDLFDASJ" v-if="userInfo">
        <p>{{ userInfo.userName }} {{ userInfo.userSex }} {{ userInfo.userAge }}岁</p>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(['userInfo']),
  },
};
</script>

<style  scoped>
@import url('./UserInformation.scss');
</style>